// This product requires a real variant. Resolve through the existing optionChange response.
export default function installExactVariantGuard(form) {
    const product = form && form.querySelector('[name="product_id"]');
    if (!product || String(product.value) !== '32196') return null;
    let generation = 0;
    let state = { ok: false, message: 'Checking selected colors. Please wait.' };
    let resolvedSignature = '';
    const signature = () => JSON.stringify(Array.from(form.elements)
        .filter(el => /^(attribute|product_option)\[/.test(el.name || '') && !el.disabled
            && (!/^(radio|checkbox)$/.test(el.type) || el.checked))
        .map(el => [el.name, String(el.value || '')]).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
    const message = document.createElement('div');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.className = 'sms-exact-variant-message';
    form.appendChild(message);
    const guard = {
        signature,
        check: () => resolvedSignature === signature() ? state : { ok: false, message: 'Checking selected colors. Please wait.' },
        begin: () => {
            generation += 1;
            resolvedSignature = '';
            state = { ok: false, message: 'Checking selected colors. Please wait.' };
            form.querySelectorAll('[name="variant_id"], [name="variation_id"]').forEach(el => { el.value = ''; });
            guard.apply();
            return { generation, signature: signature() };
        },
        current: ticket => Boolean(ticket && ticket.generation === generation && ticket.signature === signature()),
        accept: (ticket, err, data) => {
            if (!guard.current(ticket)) return false;
            const id = data && String(data.v3_variant_id || '');
            const ok = !err && data && data.base !== true && /^[1-9][0-9]*$/.test(id)
                && typeof data.sku === 'string' && data.sku.trim() && data.purchasable === true && data.instock !== false;
            state = ok ? { ok: true, variant: { id, sku: data.sku } } : {
                ok: false,
                message: err || !data ? 'Unable to check these colors. Please select your colors again.'
                    : 'This color combination is unavailable. Please select compatible table top and edge colors.',
            };
            resolvedSignature = ticket.signature;
            guard.apply();
            return true;
        },
        apply: () => {
            const result = guard.check();
            message.textContent = result.ok ? '' : result.message;
            const button = form.querySelector('#form-action-addToCart');
            if (button && !result.ok) button.disabled = true;
            return result;
        },
    };
    form.__smsExactVariantGuard = guard;
    form.addEventListener('change', event => {
        if (/^(attribute|product_option)\[/.test(event.target.name || '')) guard.begin();
    }, true);
    form.addEventListener('submit', event => {
        if (!guard.apply().ok) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    guard.apply();
    return guard;
}
